export const ARIA_LABEL = 'Cookie settings'

export const ICON_SIZE = 26
